"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const Keys_1 = require("./Keys");
const get = (path, params) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    const queryParams = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          //Transform array into item[index] string
          if (Array.isArray(value)) {
            for (let key1 in params[key]) {
              queryParams.append(`${key}[${key1}]`, params[key][key1]);
            }
          }
          //Transform object into obj[var]=value string
          else if (typeof value === "object" && value !== null) {
            for (let key2 in value) {
              const objValue = params[key][key2];
              //Transform array into item[index] string
              if (Array.isArray(objValue)) {
                for (let key1 in objValue) {
                  queryParams.append(`${key}[${key2}][${key1}]`, objValue[key1]);
                }
              } else {
                queryParams.append(`${key}[${key2}]`, objValue);
              }
            }
          } else queryParams.append(key, value.toString());
        }
      });
    }
    const url = Array.from(queryParams).length > 0 ? Keys_1.default.getServerUrl() + path + "/?" + queryParams : Keys_1.default.getServerUrl() + path;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Parse-Session-Token": Keys_1.default.getToken(),
        "X-Parse-Application-Id": Keys_1.default.getApplicationId(),
        "X-Parse-REST-API-Key": Keys_1.default.getRestApiKey()
      }
    }).then(res => {
      if (res.ok) {
        res.json().then(data => resolve(data));
      } else {
        res.json().then(data => reject(data));
      }
    });
  });
});
const post = (path, params) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    const url = Keys_1.default.getServerUrl() + path;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Parse-Session-Token": Keys_1.default.getToken(),
        "X-Parse-Application-Id": Keys_1.default.getApplicationId(),
        "X-Parse-REST-API-Key": Keys_1.default.getRestApiKey()
      },
      body: JSON.stringify(params)
    }).then(res => {
      if (res.ok) {
        res.json().then(data => resolve(data));
      } else {
        res.json().then(data => reject(data));
      }
    });
  });
});
const put = (path, body, formData) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    const url = Keys_1.default.getServerUrl() + path;
    const contentType = formData ? null : "application/json";
    const bodyData = formData ? body : JSON.stringify(body);
    fetch(url, {
      method: "PUT",
      headers: Object.assign(Object.assign({}, contentType && {
        "Content-Type": contentType
      }), {
        "X-Parse-Session-Token": Keys_1.default.getToken(),
        "X-Parse-Application-Id": Keys_1.default.getApplicationId(),
        "X-Parse-REST-API-Key": Keys_1.default.getRestApiKey()
      }),
      body: bodyData
    }).then(res => {
      if (res.ok) {
        res.json().then(data => resolve(data));
      } else {
        res.json().then(data => reject(data));
      }
    });
  });
});
const remove = (path, params) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise((resolve, reject) => {
    const url = Keys_1.default.getServerUrl() + path;
    fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-Parse-Session-Token": Keys_1.default.getToken(),
        "X-Parse-Application-Id": Keys_1.default.getApplicationId(),
        "X-Parse-REST-API-Key": Keys_1.default.getRestApiKey()
      },
      body: JSON.stringify(params)
    }).then(res => {
      if (res.ok) {
        res.json().then(data => resolve(data));
      } else {
        res.json().then(data => reject(data));
      }
    });
  });
});
exports.default = {
  get,
  post,
  put,
  remove
};